import { useQuery } from '@tanstack/react-query';
import { getUserScopeConfiguration } from '../requests';
import { useSessionStore } from '@/entities/session';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';

const useUserScopeConfiguration = () => {
  const { session } = useSessionStore();
  const { data, isLoading, error } = useQuery({
    queryKey: ['userScopeConfiguration', session?.userId],
    queryFn: getUserScopeConfiguration,
    enabled: !!session?.userId,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
  });

  return {
    userScopeConfiguration: data,
    isUserScopeConfigurationLoading: isLoading,
    userScopeConfigurationError: error,
  };
};

export { useUserScopeConfiguration };
